import { createAsyncThunk } from '@reduxjs/toolkit';

import { RefreshTokenBody } from 'models/api';

import { AccountService } from 'api/Account';

export const refreshToken = createAsyncThunk(
	'authorization/refreshToken',

	async (credentials: RefreshTokenBody, { rejectWithValue }) => {
		try {
			return await AccountService.refreshToken(credentials);
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
